import React from 'react'
import './App.css'
import { Routes, Route } from 'react-router-dom'
import Avataruplode from './pages/avataruplode'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Webrtc from './pages/webrtc';
function App() {

  return (
     <Routes>
        <Route path="/" element={<Avataruplode />} />
        <Route path="/webrtc" element={<Webrtc/>} />        
    </Routes>
  )
}

export default App
